export const getWorkExperienceModalTranslationKeys = (isVolunteering: boolean) => {
  if (isVolunteering) {
    return {
      TITLE: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.TITLE',
      POSITION_LABEL: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.POSITION_LABEL',
      EMPLOYER_LABEL: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.EMPLOYER_LABEL',
      LOCATION_LABEL: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.LOCATION_LABEL',
      START_DATE_LABEL: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.START_DATE_LABEL',
      END_DATE_LABEL: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.END_DATE_LABEL',
      END_DATE_DESCRIPTION: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.END_DATE_DESCRIPTION',
      DESCRIPTION_LABEL: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.DESCRIPTION_LABEL',
      DESCRIPTION_PLACEHOLDER: 'MY_PROFILE_PAGE.VOLUNTEER_EXPERIENCE_MODAL.DESCRIPTION_PLACEHOLDER',
    };
  }
  return {
    TITLE: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.TITLE',
    POSITION_LABEL: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.POSITION_LABEL',
    EMPLOYER_LABEL: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.EMPLOYER_LABEL',
    LOCATION_LABEL: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.LOCATION_LABEL',
    START_DATE_LABEL: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.START_DATE_LABEL',
    END_DATE_LABEL: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.END_DATE_LABEL',
    END_DATE_DESCRIPTION: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.END_DATE_DESCRIPTION',
    DESCRIPTION_LABEL: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.DESCRIPTION_LABEL',
    DESCRIPTION_PLACEHOLDER: 'MY_PROFILE_PAGE.WORK_EXPERIENCE_MODAL.DESCRIPTION_PLACEHOLDER',
  };
};
